export const ACTION_REGISTER_BEGIN_PURCHASE = 'ACTION_REGISTER_BEGIN_PURCHASE';
export const ACTION_GET_CONFIGURATION = 'ACTION_GET_CONFIGURATION';
export const ACTION_EMULATE_PAYMENT = 'ACTION_EMULATE_PAYMENT';
export const ACTION_GET_ORDER = 'ACTION_GET_ORDER';

export const ACTION_GET_CATALOG = 'ACTION_GET_CATALOG';
export const ACTION_REFRESH_CATALOG = 'ACTION_REFRESH_CATALOG';

export const ACTION_GET_CARD_OWNER_INFO = 'ACTION_GET_CARD_OWNER_INFO';

export const ACTION_REDIRECT = 'ACTION_REDIRECT';
export const ACTION_REDIRECT_REFILL = 'ACTION_REDIRECT_REFILL';
export const ACTION_REDIRECT_BUY_TICKET = 'ACTION_REDIRECT_BUY_TICKET';
export const ACTION_REDIRECT_REPORT = 'ACTION_REDIRECT_REPORT';

export const ACTION_LOAD_STATIC_IMAGES = 'ACTION_LOAD_STATIC_IMAGES';
export const ACTION_LOAD_DOC = 'ACTION_LOAD_DOC';
export const ACTION_GET_IMAGES = 'ACTION_GET_IMAGES';

export const ACTION_CARDS_HISTORY = 'ACTION_CARDS_HISTORY';
export const ACTION_CARDS_TARIFICATIONS = 'ACTION_CARDS_TARIFICATIONS';
export const ACTION_CARDS_SUBSCRIPTIONS = 'ACTION_CARDS_SUBSCRIPTIONS';

export const ACTION_PROFILE = 'ACTION_PROFILE';
export const ACTION_GET_CARD_INFO = 'ACTION_GET_CARD_INFO';
export const ACTION_PROFILE_GET_OWNER = 'ACTION_PROFILE_GET_OWNER';
export const ACTION_PROFILE_GET_COOWNERS = 'ACTION_PROFILE_GET_COOWNERS';

